import { MenuModel } from "@modules/app/types/types"
import { useUser } from "@modules/auth/hooks/useUser"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { useServicesContext } from "@modules/core/services/services.context"
import { word } from "@modules/core/utils/i18n"
import { Path } from "@modules/navigation/routes"
import { RouteNavigate } from "@modules/navigation/useBaseNavigate"
import { getBoxPath } from "@modules/navigation/useBoxNavigate"
import { getMySpacePath } from "@modules/navigation/useMySpaceNavigate"
import { useObservable } from "micro-observables"

export const useMenuModels = (ownerMenu?: boolean) => {
  const { chatService, currentSpaceManager } = useServicesContext()
  const hasUnreadMessage = !!useObservable(chatService.unreadCount)
  // PERMISSIONS
  const canSeeTimetables = useBoxStaffPermission(BoxStaffPermissions.SEE_TIMETABLES)
  const canSeeOffers = useBoxStaffPermission(BoxStaffPermissions.SEE_OFFERS)
  const canSeeMembers = useBoxStaffPermission(BoxStaffPermissions.SEE_MEMBERS)
  const canSeeFinancial = useBoxStaffPermission(BoxStaffPermissions.SEE_FINANCIAL)
  const canSeeGymInformation = useBoxStaffPermission(BoxStaffPermissions.SEE_GYM_INFORMATION)

  const user = useUser()

  const menu: MenuModel[] = []

  if (ownerMenu) {
    const itemPlanning = {
      label: word("menu.planning"),
      icon: "hup-planning",
      to: getBoxPath(Path.Box.Planning, { newBoxId: currentSpaceManager.boxId }),
    }

    const itemOffers = {
      label: word("menu.offers"),
      icon: "hup-products",
      to: getBoxPath(Path.Box.Offers, { newBoxId: currentSpaceManager.boxId }),
    }

    const itemMembers = {
      label: word("menu.members"),
      icon: "hup-members",
      to: getBoxPath(Path.Box.Members, { newBoxId: currentSpaceManager.boxId }),
    }

    const itemChat = {
      label: word("menu.chat"),
      icon: "pi pi-comments",
      to: getBoxPath(Path.Chat.Root, { newBoxId: currentSpaceManager.boxId }),
      badge: hasUnreadMessage ? ("new" as "new" | "updated") : undefined,
    }

    const itemFinances = {
      label: word("menu.finances"),
      icon: "hup-finances",
      to: getBoxPath(Path.Box.Finances, { newBoxId: currentSpaceManager.boxId }),
    }

    const itemAdmin = {
      label: word("menu.admin"),
      icon: "hup-admin",
      to: getBoxPath(Path.Box.Admin, { newBoxId: currentSpaceManager.boxId }),
    }

    if (canSeeTimetables) {
      menu.push(itemPlanning)
    }

    if (canSeeOffers) {
      menu.push(itemOffers)
    }

    if (canSeeMembers) {
      menu.push(itemMembers)
    }

    menu.push(itemChat)

    if (canSeeFinancial) {
      menu.push(itemFinances)
    }

    if (canSeeGymInformation) {
      menu.push(itemAdmin)
    }
  } else {
    const itemDashboard = {
      label: word("menu.dashboard"),
      icon: "hup-dashboard",
      to: getMySpacePath(RouteNavigate.Root),
    }
    const itemExplorer = {
      label: word("menu.explorer"),
      icon: "hup-explorer",
      to: getMySpacePath(Path.MySpace.Explore),
    }
    const itemTraining = {
      label: word("menu.training"),
      icon: "hup-training",
      to: getMySpacePath(Path.MySpace.Training),
    }
    const itemChat = {
      label: word("menu.chat"),
      icon: "pi pi-comments",
      to: getMySpacePath(Path.Chat.Root),
      badge: hasUnreadMessage ? ("new" as "new" | "updated") : undefined,
    }
    const itemFinances = {
      label: word("menu.transactions"),
      icon: "hup-finances",
      to: getMySpacePath(Path.MySpace.Finances),
    }
    // const itemTutorials = {
    //   label: word("menu.tutorials"),
    //   icon: "hup-tutorials",
    //   to: getMySpacePath(Path.MySpace.Tutorials),
    // }

    menu.push(itemDashboard)
    menu.push(itemExplorer)
    menu.push(itemTraining)
    menu.push(itemChat)
    if (user?.stripeAccountId && user.stripeAccountStatus === "OK") menu.push(itemFinances)
    // menu.push(itemTutorials)
  }

  const menuModels: MenuModel[] = [
    {
      label: "Hustleup",
      icon: "pi pi-home",
      items: menu,
    },
  ]

  return menuModels
}
